module.exports = __webpack_public_path__ + "img/sardinia.bb255e01.svg";